'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = materialize;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _adapterType = require('../adapters/adapter-type');

var _adapterType2 = _interopRequireDefault(_adapterType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getDesiredState = function getDesiredState(name, materializer) {
  if (materializer.renderBuffer['render:' + name] == null) return {
    isMounted: false,
    props: {},
    context: {}
  };

  var _materializer$renderB = _slicedToArray(materializer.renderBuffer['render:' + name], 3),
      data = _materializer$renderB[0],
      handlerNames = _materializer$renderB[1],
      context = _materializer$renderB[2];

  var buildHandler = function buildHandler(handlerName) {
    return function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return materializer.handle(name, handlerName, args);
    };
  };

  var props = _extends({}, data, handlerNames.reduce(function (acc, handlerName) {
    return _extends({}, acc, _defineProperty({}, handlerName, buildHandler(handlerName)));
  }, {}));

  return { isMounted: true, props: props, context: context };
};

function materialize(_ref) {
  var name = _ref.name,
      constructor = _ref.constructor,
      _ref$contextTypes = _ref.contextTypes,
      contextTypes = _ref$contextTypes === undefined ? {} : _ref$contextTypes;

  var Materialize = function (_Component) {
    _inherits(Materialize, _Component);

    function Materialize(props, context) {
      _classCallCheck(this, Materialize);

      var _this = _possibleConstructorReturn(this, (Materialize.__proto__ || Object.getPrototypeOf(Materialize)).call(this, props, context));

      var materializer = _this.context.entanglement.materializer;


      _this.state = getDesiredState(name, materializer);

      _this.handleUnmount = _this.handleUnmount.bind(_this);
      _this.handleRender = _this.handleRender.bind(_this);
      return _this;
    }

    _createClass(Materialize, [{
      key: 'getChildContext',
      value: function getChildContext() {
        return this.state.context || {};
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        var materializer = this.context.entanglement.materializer;


        this.dismissers = [materializer.addRenderListener(name, this.handleRender), materializer.addUnmountListener(name, this.handleUnmount)];
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.dismissers.forEach(function (dismisser) {
          return dismisser();
        });
        this.dismissers = [];
      }
    }, {
      key: 'handleUnmount',
      value: function handleUnmount() {
        this.setState({ isMounted: false });
      }
    }, {
      key: 'handleRender',
      value: function handleRender(data, handlerNames, context) {
        var materializer = this.context.entanglement.materializer;


        var buildHandler = function buildHandler(handlerName) {
          return function () {
            for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              args[_key2] = arguments[_key2];
            }

            return materializer.handle(name, handlerName, args);
          };
        };

        var props = _extends({}, data, handlerNames.reduce(function (acc, handlerName) {
          return _extends({}, acc, _defineProperty({}, handlerName, buildHandler(handlerName)));
        }, {}));

        this.setState({ isMounted: true, props: props, context: context });
      }
    }, {
      key: 'render',
      value: function render() {
        var _state = this.state,
            isMounted = _state.isMounted,
            props = _state.props;

        return isMounted && _react2.default.createElement(constructor, props);
      }
    }]);

    return Materialize;
  }(_react.Component);

  Materialize.displayName = 'Entanglement.materialize.' + name;

  Materialize.contextTypes = {
    entanglement: _adapterType2.default
  };

  Materialize.childContextTypes = _extends({
    entanglement: _adapterType2.default
  }, contextTypes);

  return Materialize;
}